#import "../fragments/mcfx-viq-contact-fragment.graphql"

query GetMcfxViqContacts($id: ID!) {
    mcfxViqContacts(id: $id) {
        ...McfxViqContactFragment
    }
}
